import React from 'react';

const IMAGE_SIZE = 40;
export function FeedRecommendedFollowsUserCellSkeleton() {
  return (
    <div className="flex flex-col items-center gap-2 lt:flex-row">
      <div
        className="animate-pulse rounded-full bg-neutral100"
        style={{ width: IMAGE_SIZE, height: IMAGE_SIZE }}
      />
      <div className="flex flex-1 flex-col gap-2">
        <div className="h-2 w-40 animate-pulse rounded-full bg-neutral100" />
        <div className="h-2 w-24 animate-pulse rounded-full bg-neutral100" />
      </div>
    </div>
  );
}
